import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { ApiChannel } from 'core/constants';
import { buildHeaders, XmStore } from 'core/services';
import { ReturnEligibilityCollection } from './models';
import { StoreAction } from 'store/actions';

@Injectable()
export class ReturnEligibilityApi {
    public static getReturnEligibility(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<ReturnEligibilityCollection> {
        return http.get(`/orders/${params.orderId}/returneligibility`, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((returnEligibility: ReturnEligibilityCollection) => ReturnEligibilityCollection.create<ReturnEligibilityCollection>({ returnEligibility, orderId: params.orderId }))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_RETURN_ELIGIBILITY_COLLECTION] = ReturnEligibilityApi.getReturnEligibility;
